import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import EnglishFlagIcon from '@/components/CustomIcons/EnglishFlagIcon.vue';
import GreekFlagIcon from '@/components/CustomIcons/GreekFlagIcon.vue';
import SpanishFlagIcon from '@/components/CustomIcons/SpanishFlagIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#01777A'
      },
    },
  },
  icons: {
    values: {
      en_flag: {
        component: EnglishFlagIcon,
      },
      el_flag: {
        component: GreekFlagIcon,
      },
      es_flag: {
        component: SpanishFlagIcon,
      }
    }
  }
});
